import PropTypes from 'prop-types';
import { notification } from 'antd';

const NotificationModal = (customIcon, message, description) => {
  const customProps = {
    icon: customIcon,
    message,
    description,
  };

  return notification.warning(customProps);
};

NotificationModal.propTypes = {
  customIcon: PropTypes.element.isRequired,
  message: PropTypes.string.isRequired,
  description: PropTypes.string,
};

NotificationModal.defaultProps = {
  customIcon: undefined,
  message: '',
  description: '',
};

export default NotificationModal;
